import React from "react";
import '../../../model/index.css';

const P1 = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">Napoli Coffee</h1>
      <div className="section">
        <h2>"United States, New Mexico, Albuquerque.</h2>
        <p className="store-info"></p>
        <img src="./partner/1/1.pic.jpg"  alt=""/>
        <img src="./partner/1/2.pic.jpg"  alt=""/>
        <img src="./partner/1/3.pic.jpg"  alt=""/>
        <img src="./partner/1/4.pic.jpg"  alt=""/>
        <img src="./partner/1/5.pic.jpg"  alt=""/>
        <img src="./partner/1/6.pic.jpg"  alt=""/>
        <img src="./partner/1/7.pic.jpg"  alt=""/>
        <img src="./partner/1/8.pic.jpg"  alt=""/>
        <img src="./partner/1/9.pic.jpg"  alt=""/>
      </div>

    </div>
  );
};

export default P1;
